"use strict";function e(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var t=e(require("react-dom/server"));exports.default=e=>{let r="";return e.forEach((e=>{Object.entries(e).forEach((e=>{const[o,u]=e;r="symbol"==typeof u.$$typeof?r+o+"'"+t.default.renderToStaticMarkup(u)+"'":"object"==typeof u?r+o+JSON.stringify(u):r+o+u}))})),r};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/checkboxes/cjs/utils/stringifyObj.js
// module id = 909
// module chunks = 0